import { useState } from 'react';
import { authStaff } from '../../utils/constants';
import { useDispatch, useSelector } from "react-redux";
import { selectAccessToken, selectStaffId } from "../../slices/staffSlice";
import { adminPortalRequest } from '../../Requests/getRequests';
import { Loader } from "../../components";
import { show } from '../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';

function Verify({ status }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const clientId = useSelector(selectStaffId);
    const [verifyLoader, setVerifyLoader] = useState(false);

    const verifyAccount = async() => {
        setVerifyLoader(true);
        let verifyUrl = `/auth/staff/client/verify`;
        let headers = authStaff(accessToken);
        let data = { _id: clientId };

        let res = await adminPortalRequest(verifyUrl, "PUT", headers, {}, data);
        setVerifyLoader(false);

        if(res?.code === 401){
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }

        if(res?.err){
            dispatch(show({ type: "error", state: true, message: `${res?.err}` }));
            return;
        }

        dispatch(show({ type: "success", state: true, message: "Account verification updated successfully!" }));
        setTimeout(() => { window.location.reload(); }, 1500);
    }

    return (
        <span
            className={`action-buttons ${status ?
                'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-700 border-0'
                :
                'bg-emerald-100 text-emerald-700 hover:bg-emerald-200 hover:text-emerald-700 border-0'}`
            }
            onClick={verifyAccount}
        >
            {verifyLoader ?
                <Loader color="text-gray-700" size="5" />
                :
                status ? "Unverify Account" : "Verify Account"
            }
        </span>
    )
}

export default Verify
